jQuery(document).ready(function () {
    if ($('.blog').length > 0) {
        var allReal = $(".blog_singleArticle");
        var thematique;
        $(".blog_filter").click(function () {
            $(".blog_filter").removeClass('blog_filter-active')
            $(this).toggleClass('blog_filter-active')
            thematique = $(this).attr('id');
            console.log(thematique);
            allReal.hide();
            allReal.each(function (index) {
                if( thematique == "all"){
                    allReal.show();
                }
                else{
                    if ($(this).data(thematique)) {
                        $(this).show();
                    }
                }
            });
        })
    }
});
